import * as fromDatatype from "../datatype-library";

export interface bl_alg_cc_task_ext_RowInterface {
    //public static final String tableAlias = "task_ext";
    guid : fromDatatype.GuidDataFieldInterface;
    hdr_guid : fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.VarcharDatatypeInterface;
    ext_type : fromDatatype.VarcharDatatypeInterface;
    ext_code : fromDatatype.VarcharDatatypeInterface;
    ext_optio : fromDatatype.VarcharDatatypeInterface;
    //private Map<String, Object> property_json = new HashMap<String, Object>();
    property_json : fromDatatype.JsonDatatypeInterface
    param_code : fromDatatype.VarcharDatatypeInterface;
    param_name : fromDatatype.VarcharDatatypeInterface;
    param_type : fromDatatype.VarcharDatatypeInterface;
    //private Map<String, Object> param_option_json = new HashMap<String, Object>();
    param_option_json : fromDatatype.JsonDatatypeInterface
    value_string : fromDatatype.VarcharDatatypeInterface;
    value_file : fromDatatype.VarcharDatatypeInterface;
    value_numeric : fromDatatype.BigIntegerDatatypeInterface;
    value_datetime : fromDatatype.TimestampTzDatatypeInterface;
    //private Map<String, Object> value_json = new HashMap<String, Object>();
    value_json : fromDatatype.JsonDatatypeInterface
    //private Map<String, Object> acl_config = new HashMap<String, Object>();
    acl_config : fromDatatype.JsonDatatypeInterface
    //private Map<String, Object> acl_policy = new HashMap<String, Object>();
    acl_policy : fromDatatype.JsonDatatypeInterface
    created_date : fromDatatype.TimestampTzDatatypeInterface;
    updated_date : fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    //private StatusColumn status;
    status : fromDatatype.StatusDataFieldInterface
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_task_ext_RowClass
  implements bl_alg_cc_task_ext_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    hdr_guid : fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.VarcharDatatypeInterface;
    ext_type : fromDatatype.VarcharDatatypeInterface;
    ext_code : fromDatatype.VarcharDatatypeInterface;
    ext_optio : fromDatatype.VarcharDatatypeInterface;
    //private Map<String, Object> property_json = new HashMap<String, Object>();
    property_json : fromDatatype.JsonDatatypeInterface
    param_code : fromDatatype.VarcharDatatypeInterface;
    param_name : fromDatatype.VarcharDatatypeInterface;
    param_type : fromDatatype.VarcharDatatypeInterface;
    //private Map<String, Object> param_option_json = new HashMap<String, Object>();
    param_option_json : fromDatatype.JsonDatatypeInterface
    value_string : fromDatatype.VarcharDatatypeInterface;
    value_file : fromDatatype.VarcharDatatypeInterface;
    value_numeric : fromDatatype.BigIntegerDatatypeInterface;
    value_datetime : fromDatatype.TimestampTzDatatypeInterface;
    //private Map<String, Object> value_json = new HashMap<String, Object>();
    value_json : fromDatatype.JsonDatatypeInterface
    //private Map<String, Object> acl_config = new HashMap<String, Object>();
    acl_config : fromDatatype.JsonDatatypeInterface
    //private Map<String, Object> acl_policy = new HashMap<String, Object>();
    acl_policy : fromDatatype.JsonDatatypeInterface
    created_date : fromDatatype.TimestampTzDatatypeInterface;
    updated_date : fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    //private StatusColumn status;
    status : fromDatatype.StatusDataFieldInterface
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
}